/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Whatwedo_Communities2Inputs */

const ja_careers_whatwedo_communities2 = /** @type {(inputs: Careers_Whatwedo_Communities2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームコミュニティへのアプローチ`)
};

const en_careers_whatwedo_communities2 = /** @type {(inputs: Careers_Whatwedo_Communities2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game Communities and Media`)
};

/**
* | output |
* | --- |
* | "Game Communities and Media" |
*
* @param {Careers_Whatwedo_Communities2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_whatwedo_communities2 = /** @type {((inputs?: Careers_Whatwedo_Communities2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Whatwedo_Communities2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_whatwedo_communities2(inputs)
	return en_careers_whatwedo_communities2(inputs)
});
export { careers_whatwedo_communities2 as "careers_whatWeDo_communities" }